import React, { ReactElement } from "react";

import { PageMeta } from "@shared/seo/page-meta";

import { ScrollStory } from "./scroll-story";

export const HomePage: React.FC = (): ReactElement => {
    return (
        <>
            <PageMeta
                title="Plumme — закрытое клубное пространство ваших возможностей"
                description="Клубы, события и люди, отобранные по интересам и ценностям. Пространство для общения, нетворкинга и совместного досуга."
                path="/"
            />

            <ScrollStory />
        </>
    );
};